import { logisticRoutes, LogisticRouteOption } from '../../domain'

export function useLogisticRoutes(): Record<string, LogisticRouteOption[]> {
  return {
    logisticRoutes,
  }
}
